/**
 * Browser Compatibility Warning Hook
 * 
 * This hook manages the display of browser compatibility warnings using snackbars.
 * It ensures the warning is shown only once per browser session for unsupported browsers.
 */

import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { 
  shouldShowBrowserWarning, 
  getBrowserWarningMessage, 
  markBrowserWarningAsShown 
} from '@/taskpane/utils/browserCompatibility';

/**
 * Hook that automatically shows a browser compatibility warning if needed
 * Should be called once during application initialization
 */
export function useBrowserCompatibilityWarning() {
  useEffect(() => {
    // Check if we should show the warning
    if (shouldShowBrowserWarning()) {
      // Show the warning snackbar
      enqueueSnackbar(getBrowserWarningMessage(), {
        variant: 'warning',
        autoHideDuration: 7000, // Auto-hide after 7 seconds
        preventDuplicate: true,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      });

      // Mark the warning as shown so it doesn't appear again
      markBrowserWarningAsShown();
    }
  }, []); // Empty dependency array - run only once on mount
}